import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRetoolIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 48,
		height: 48,
		rx: 8,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M33.9854 31C34.5457 31.0002 35 31.4925 35 32.0996V32.8008C35 34.0153 34.0908 35 32.9697 35H25.0303C23.9092 35 23 34.0153 23 32.8008V32.0996C23 31.4925 23.4543 31.0002 24.0146 31H33.9854ZM32.9844 20C34.0976 20.0001 35 20.9848 35 22.1992V27.9004C35 28.5076 34.5488 29 33.9922 29H15.0156C13.9024 28.9999 13 28.0152 13 26.8008V21.0996C13 20.4924 13.4512 20.0001 14.0078 20H32.9844ZM22.9697 13C24.0908 13 25 13.9847 25 15.1992V16.9004C25 17.5075 24.5457 17.9998 23.9854 18H14.0146C13.4542 17.9998 13 17.5075 13 16.9004V15.1992C13 13.9847 13.9092 13 15.0303 13H22.9697Z",
		fill: "#262626"
	})]
});
export default SvgRetoolIcon;
